import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "removeInput", "removeButton", "error"]
  static values = {
    maxSize: Number,
    allowedTypes: String,
    placeholderText: String,
    placeholderFontSize: Number
  }

  connect() {
    this.objectUrl = null
    this.originalPreviewHtml = this.previewTarget.innerHTML
  }

  disconnect() {
    this.revokeObjectUrl()
  }

  preview() {
    const file = this.inputTarget.files[0]

    this.clearError()

    if (!file) {
      this.restoreEmptyPreview()
      return
    }

    if (!this.allowedTypeList.includes(file.type)) {
      this.rejectFile("Selecione uma imagem PNG, JPG ou WebP.")
      return
    }

    if (file.size > this.maxSizeValue) {
      this.rejectFile(`A imagem deve ter no maximo ${this.formattedMaxSize}.`)
      return
    }

    this.removeInputTarget.value = "0"
    this.revokeObjectUrl()
    this.objectUrl = URL.createObjectURL(file)
    this.renderImage(this.objectUrl, "Preview do avatar")
  }

  remove() {
    this.clearSelectedFile()
    this.clearError()
    this.revokeObjectUrl()
    this.removeInputTarget.value = "1"
    this.renderPlaceholder()

    if (this.hasRemoveButtonTarget) {
      this.removeButtonTarget.classList.add("d-none")
    }
  }

  rejectFile(message) {
    this.clearSelectedFile()
    this.restoreEmptyPreview()
    this.inputTarget.setCustomValidity(message)
    this.errorTarget.textContent = message
    this.inputTarget.reportValidity()
  }

  clearError() {
    this.inputTarget.setCustomValidity("")
    this.errorTarget.textContent = ""
  }

  clearSelectedFile() {
    this.inputTarget.value = ""
  }

  restoreOriginalPreview() {
    this.revokeObjectUrl()
    this.previewTarget.innerHTML = this.originalPreviewHtml
  }

  restoreEmptyPreview() {
    if (this.removeInputTarget.value === "1") {
      this.renderPlaceholder()
    } else {
      this.restoreOriginalPreview()
    }
  }

  renderPlaceholder() {
    const placeholder = document.createElement("span")
    placeholder.textContent = this.placeholderTextValue
    placeholder.style.fontSize = `${this.placeholderFontSizeValue}px`
    this.previewTarget.replaceChildren(placeholder)
  }

  renderImage(src, alt) {
    const image = document.createElement("img")
    image.src = src
    image.alt = alt
    this.previewTarget.replaceChildren(image)
  }

  revokeObjectUrl() {
    if (!this.objectUrl) return

    URL.revokeObjectURL(this.objectUrl)
    this.objectUrl = null
  }

  get allowedTypeList() {
    return this.allowedTypesValue.split(",").map((type) => type.trim()).filter(Boolean)
  }

  get formattedMaxSize() {
    return `${Math.floor(this.maxSizeValue / 1024 / 1024)} MB`
  }
}
